import React from 'react';
import Flag from '@atlaskit/flag';
import StatusSuccessIcon from '@atlaskit/icon/core/status-success';
import { B300 } from '@atlaskit/theme/colors';
var RefreshBanner = function RefreshBanner(_ref) {
  var reloadEP = _ref.reloadEP,
    title = _ref.title,
    actionLabel = _ref.actionLabel;
  return /*#__PURE__*/React.createElement(Flag, {
    icon: /*#__PURE__*/React.createElement(StatusSuccessIcon, {
      spacing: "spacious",
      color: "var(--ds-icon-information, ".concat(B300, ")"),
      label: "Info"
    }),
    id: "refreshBanner",
    title: title,
    actions: [{
      content: actionLabel,
      onClick: reloadEP
    }]
  });
};
export default RefreshBanner;